import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavService } from '../../_services/_nav.service';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Location } from '@angular/common';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { Table } from 'primeng/table';
import { Funcionalidad } from '../../_models/funcionalidad';
import { TipoRespaldoService } from '../../_services/tipo-respaldo.service';
import { TipoRespaldoCategoria } from '../../_models/tipo-respaldo-categoria';
import { TipoRespaldoSubcategoriaService } from '../../_services/tipo-respaldo-subcategoria.service';
import { TipoRespaldoSubcategoria } from '../../_models/tipo-respaldo-subcategoria';
import { TipoRespaldoSubcategoriaDetalle } from '../../_models/tipo-respaldo-subcategoria-detalle';
import { TipoRespaldoSubcategoriaDetalleService } from '../../_services/tipo-respaldo-subcategoria-detalle.service';
import { forkJoin } from 'rxjs';
import { ListaService } from '../../_services/lista.service';
import { ListaItem } from '../../_models/lista-item';

@Component( {
  selector: 'app-tipo-respaldo-clase',
  templateUrl: 'tipo-respaldo-clase.component.html'
} )

export class TipoRespaldoClaseComponent implements OnInit {

  @Input()
  set respaldoSubcategoria( respaldoCategoria: TipoRespaldoSubcategoria ) {
    this._respaldoSubcategoria = respaldoCategoria;
    this.cargaInicial();
  }

  get respaldoSubcategoria(): TipoRespaldoSubcategoria {
    return this._respaldoSubcategoria;
  }

  _respaldoSubcategoria: TipoRespaldoSubcategoria;
  respaldoSubcategoriaDetalle: TipoRespaldoSubcategoriaDetalle;
  carInformacionInicial = true;
  guardando = false;
  lisTipoRespaldoClases: TipoRespaldoSubcategoriaDetalle[] = [];
  lisClasesTodos: ListaItem[] = [];
  lisClases: SelectItem[] = [];
  lisSubClasesTodos: ListaItem[] = [];
  lisSubClases: SelectItem[] = [];
  lisSubClasesTodosExis: ListaItem[] = [];
  lisSubClasesExis: SelectItem[] = [];
  formulario: FormGroup;
  submitted = false;
  carTabla = true;
  columnas: any[];
  busqueda: string;
  // esPorcentaje = false;
  editarRegistro: boolean = false;
  @ViewChild('dt') tabla: Table;
  menu: Funcionalidad = new Funcionalidad();

  constructor( private serTipoRespaldoSubcategoriaDetalle: TipoRespaldoSubcategoriaDetalleService,
               private navServicio: NavService,
               private route: ActivatedRoute,
               private location: Location,
               private fb: FormBuilder,
               private autServicio: AutenticacionService,
               private conServicio: ConfirmationService,
               private router: Router,
               private serLista: ListaService ) {
  }

  ngOnInit(): void {
    //this.cargaInicial();
  }

  cargaInicial() {
    this.lisTipoRespaldoClases = [];
    if ( this._respaldoSubcategoria && (this._respaldoSubcategoria.idTipoRespaldoSubCategoria !== '' && this._respaldoSubcategoria.idTipoRespaldoSubCategoria !== null && this._respaldoSubcategoria.idTipoRespaldoSubCategoria !== undefined) ) {
      /** Se traen todos los seguros planes que pertenezcan al seguro actual */
      this.serTipoRespaldoSubcategoriaDetalle.listadoPorIdSubcategoria( this._respaldoSubcategoria.idTipoRespaldoSubCategoria ).subscribe( tipoRespaldoClase => {
        this.lisTipoRespaldoClases = tipoRespaldoClase;
        this.carServiciosIniciales();
      } );
    }
  }

  carServiciosIniciales() {

    const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'apl/tipo-respaldo-clase' );
    if ( mn ) {
      this.menu = mn;
    }

    this.columnas = [
      { field: 'nombreClaseRespaldo', header: this.navServicio.buscarMensaje( 'TIPORESPALDO.LBL_CLASE' ), sort: true },
      { field: 'nombreSubclaseRespaldo', header: this.navServicio.buscarMensaje( 'TIPORESPALDO.LBL_SUBCLASE' ), sort: true },
      { field: 'valorSMMLV', header: this.navServicio.buscarMensaje( 'TIPORESPALDO.LBL_VALORSMMLV' ), sort: true },
      { field: 'valorPorcentaje', header: this.navServicio.buscarMensaje( 'TIPORESPALDO.LBL_VALORPORCENTAJE' ), sort: true },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];

    this.formulario = this.fb.group( {
      idTipoRespaldoSubCategoriaDetalle: [ this.respaldoSubcategoriaDetalle ? this.respaldoSubcategoriaDetalle.idTipoRespaldoSubCategoriaDetalle : null ],
      idTipoRespaldoSubCategoria: [ this._respaldoSubcategoria ? this._respaldoSubcategoria.idTipoRespaldoSubCategoria : null, [ Validators.required ] ],
      idClaseRespaldo: [ this.respaldoSubcategoriaDetalle ? this.respaldoSubcategoriaDetalle.idClaseRespaldo : null, [ Validators.required ] ],
      idSubClaseRespaldo: [ this.respaldoSubcategoriaDetalle ? this.respaldoSubcategoriaDetalle.idSubClaseRespaldo : null ],
      valorSMMLV: [ this.respaldoSubcategoriaDetalle ? this.respaldoSubcategoriaDetalle.valorSMMLV : null, [ Validators.required ] ],
      valorPorcentaje: [ this.respaldoSubcategoriaDetalle ? this.respaldoSubcategoriaDetalle.valorPorcentaje : null, [ Validators.required ] ],
      indicadorHabilitado: [ true, [ Validators.required ] ],
    } );

    forkJoin( this.serLista.getMasterDetails( 'ListasClasesRespaldos' )).subscribe( ( [ clases] ) => {
      this.lisClases = [];
      this.lisClasesTodos = clases;

      this.lisClasesTodos.map( ( s: ListaItem ) => {
        this.lisClases.push( { label: s.nombre, value: s.idLista } );
      } );
    } );

    this.busqueda = this.navServicio.getSearch( 'tipo-respaldo-clase.component' );
    this.carTabla = false;
    this.carInformacionInicial = false;
  }


  onSubmit() {
    this.submitted = true;
    if ( this.formulario.valid ) {
      this.guardando = true;
      this.carTabla = true;
      const formulario = this.formulario.getRawValue();
      if ( this.verificarClase( this.f.idClaseRespaldo.value ) ) {
        this.guardando = false;
        this.carTabla = false;
        this.navServicio.setMesage( 0, {
          severity: 'error', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
          detail: this.navServicio.buscarMensaje( 'TIPORESPALDO.MSG_ERRORCLASE' )
        } );
      } else {
        let existe = null;
        if (this.editarRegistro) {
          existe = this.lisTipoRespaldoClases.find( x =>
            (x.idSubClaseRespaldo === formulario.idSubClaseRespaldo && x.idClaseRespaldo === formulario.idClaseRespaldo && x.indicadorHabilitado) ||
            (x.idSubClaseRespaldo === null && x.idClaseRespaldo === formulario.idClaseRespaldo && x.indicadorHabilitado) );
        } else {
          existe = this.lisTipoRespaldoClases.find( x =>
            (x.idSubClaseRespaldo === formulario.idSubClaseRespaldo && x.idClaseRespaldo === formulario.idClaseRespaldo && !x.indicadorHabilitado) ||
            (x.idSubClaseRespaldo === null && x.idClaseRespaldo === formulario.idClaseRespaldo && !x.indicadorHabilitado) );
        }

        if ( existe ) {
          /** Se actualiza la clase */
          formulario.idTipoRespaldoSubCategoriaDetalle = existe.idTipoRespaldoSubCategoriaDetalle;
          formulario.indicadorHabilitado = true;
          this.serTipoRespaldoSubcategoriaDetalle.actualizar( formulario ).subscribe( tipoRespaldoCategoria => {
            this.lisTipoRespaldoClases = [];
            this.serTipoRespaldoSubcategoriaDetalle.listadoPorIdSubcategoria( this._respaldoSubcategoria.idTipoRespaldoSubCategoria ).subscribe( lisRespaldoCategoria => {
              this.lisTipoRespaldoClases = lisRespaldoCategoria;
              this.guardando = false;
              this.submitted = false;
              this.carTabla = false;
              this.respaldoSubcategoriaDetalle = null;
              this.editarRegistro = false;
              this.formulario.reset();
              this.f.idTipoRespaldoSubCategoria.setValue( this._respaldoSubcategoria.idTipoRespaldoSubCategoria );
              this.f.indicadorHabilitado.setValue( true );
              this.navServicio.setMesage( 0, {
                severity: 'success', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
                detail: this.navServicio.buscarMensaje( 'TIPORESPALDO.MSG_ACTUALIZO' )
              } );
            } );
          } );
        } else {
          /** Se crea la clase */
          this.serTipoRespaldoSubcategoriaDetalle.crear( formulario ).subscribe( tipoRespaldoCategoria => {
            this.lisTipoRespaldoClases = [];
            this.serTipoRespaldoSubcategoriaDetalle.listadoPorIdSubcategoria( this._respaldoSubcategoria.idTipoRespaldoSubCategoria ).subscribe( lisRespaldoCategoria => {
              this.lisTipoRespaldoClases = lisRespaldoCategoria;
              this.guardando = false;
              this.submitted = false;
              this.carTabla = false;
              this.respaldoSubcategoriaDetalle = null;
              this.formulario.reset();
              this.editarRegistro = false;
              this.f.idTipoRespaldoSubCategoria.setValue( this._respaldoSubcategoria.idTipoRespaldoSubCategoria );
              this.f.indicadorHabilitado.setValue( true );
              this.navServicio.setMesage( 0, {
                severity: 'success', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
                detail: this.navServicio.buscarMensaje( 'TIPORESPALDO.MSG_CREO' )
              } );
            } );
          } );
        }
      }
    }
  }

  editar( dataRespaldo: TipoRespaldoSubcategoriaDetalle ) {
    this.formulario.reset();
    this.respaldoSubcategoriaDetalle = null;
    this.f.idTipoRespaldoSubCategoriaDetalle.setValue( dataRespaldo.idTipoRespaldoSubCategoriaDetalle );
    this.f.idTipoRespaldoSubCategoria.setValue( dataRespaldo.idTipoRespaldoSubCategoria );
    this.f.idClaseRespaldo.setValue( dataRespaldo.idClaseRespaldo );
    this.f.idSubClaseRespaldo.setValue( dataRespaldo.idSubClaseRespaldo );
    this.f.valorSMMLV.setValue( dataRespaldo.valorSMMLV );
    this.f.valorPorcentaje.setValue( dataRespaldo.valorPorcentaje );
    this.f.indicadorHabilitado.setValue( dataRespaldo.indicadorHabilitado );
    this.respaldoSubcategoriaDetalle = dataRespaldo;
    this.editarRegistro  = true;
    this.verificarSubclase();
  }

  regresar( dirty: boolean ) {
    if ( dirty ) {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        accept: () => {
          this.location.back();
        },
        reject: () => {
        }
      } );
    } else {
      this.location.back();
    }
  }

  verificarSubclase() {
    this.serLista.getMasterDetailsByDependency( 'ListasClasesRespaldos', this.f.idClaseRespaldo.value, 'CLASE' ).subscribe( lisSubclases => {
      this.lisSubClases = [];
      this.lisSubClasesTodos = lisSubclases;
      this.lisSubClasesTodos.map( ( s: ListaItem ) => {
        if ( !this.lisTipoRespaldoClases.find( x => x.idSubClaseRespaldo === s.idLista && x.indicadorHabilitado === true ) ) {
          this.lisSubClases.push( { label: s.nombre, value: s.idLista } );
        }
      } );
    } );
  }

  verificarClase( id: any ): boolean {
    if (this.editarRegistro) {
      return false;
    }
    if ( (!this.lisTipoRespaldoClases.find( x => x.idClaseRespaldo == id )) ||
      (this.lisTipoRespaldoClases.find( x => x.idClaseRespaldo == id && x.indicadorHabilitado ) && this.lisSubClases.length > 0 )||
      (this.lisTipoRespaldoClases.find( x => x.idClaseRespaldo == id && !x.indicadorHabilitado ))) {
      return false;
    } else {
      return true;
    }
  }

  get f() {
    return this.formulario.controls;
  }

  setBusqueda() {
    this.navServicio.setSearch( 'tipo-respaldo-clase.component', this.busqueda );
  }

  datosTabla() {
    return this.lisTipoRespaldoClases.filter( x => x.indicadorHabilitado === true );
  }

  eliminar( tipoRespaldo: TipoRespaldoSubcategoriaDetalle ) {
    /** Se actualiza la categoría */
    tipoRespaldo.indicadorHabilitado = false;
    this.serTipoRespaldoSubcategoriaDetalle.actualizar( tipoRespaldo ).subscribe( tipoRespaldoCategoria => {
      this.lisTipoRespaldoClases = [];
      this.serTipoRespaldoSubcategoriaDetalle.listadoPorIdSubcategoria( this._respaldoSubcategoria.idTipoRespaldoSubCategoria ).subscribe( lisRespaldoCategoria => {
        this.lisTipoRespaldoClases = lisRespaldoCategoria;
        this.guardando = false;
        this.submitted = false;
        this.carTabla = false;
        this.editarRegistro = false;
        this.respaldoSubcategoriaDetalle = null;
        this.formulario.reset();
        this.f.idTipoRespaldoSubCategoria.setValue( this._respaldoSubcategoria.idTipoRespaldoSubCategoria );
        this.f.indicadorHabilitado.setValue( true );
        this.navServicio.setMesage( 0, {
          severity: 'success', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
          detail: this.navServicio.buscarMensaje( 'TIPORESPALDO.MSG_ACTUALIZO' )
        } );
      } );
    } );
  }

  limpiar() {
    this.guardando = false;
    this.submitted = false;
    this.carTabla = false;
    this.respaldoSubcategoriaDetalle = null;
    this.editarRegistro = false;
    this.formulario.reset();
    this.f.idTipoRespaldoSubCategoria.setValue( this._respaldoSubcategoria.idTipoRespaldoSubCategoria );
    this.f.indicadorHabilitado.setValue( true );
  }


}
